import React from "react";
import Button from "../../../Components/Common/Button";
import { Link, useNavigate } from "react-router-dom";
import { publicUrls } from "../../../Api/Auth/AppUrls";

const News = ({ items = [] }) => {
  const navigate = useNavigate();
  const news = Array.isArray(items) ? items.slice(0, 2) : [];

  if (!news.length) {
    return null;
  }

  return (
    <div className="sm:mt-24 mt-12 mb-10">
      <Link to={publicUrls.NewsArchive}>
        <h2 className="text-3xl font-semibold text-primary text-center mt-4">
          News Archive
        </h2>
      </Link>
      <div className="pt-12">
        <div className="container mx-auto grid grid-cols-1 gap-6">
          {news.map((item) => (
            <div
              key={item._id}
              className="flex items-center gap-6 bg-primary p-6 rounded-md shadow-md"
            >
              <div className="w-1/3">
                {item.link && (
                  <img
                    src={item.link}
                    alt={item.title}
                    className="w-full h-72 object-cover rounded-md"
                  />
                )}
              </div>

              <div className="w-2/3 space-y-3">
                <h3 className="text-white text-xl font-semibold cursor-pointer">
                  {item.title}
                </h3>
                <p className="text-sm text-white font-thin font-medium">
                  {item.description?.replace(/<[^>]+>/g, "").slice(0, 160)}
                </p>
                <Button
                  onClick={() =>
                    navigate(publicUrls.News.replace(":slug", item.slug))
                  }
                  className="mt-2 border-white text-white"
                  type="outline"
                >
                  See News
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default News;
